<template>
  <svg viewBox="0 0 50.06 50.24">
    <g id="Laag_3">
      <path
        class="st0"
        d="M9.77,37.99c-2.05-2.97-3.25-6.57-3.25-10.46c0-10.19,8.26-18.45,18.45-18.45s18.45,8.26,18.45,18.45
		c0,3.91-1.22,7.53-3.29,10.52"
      />
      <line class="st0" x1="11" y1="35.42" x2="13.5" y2="33.99" />
      <line class="st0" x1="9.17" y1="27.48" x2="12.04" y2="27.5" />
      <line class="st0" x1="11.24" y1="19.65" x2="13.72" y2="21.1" />
      <line class="st0" x1="17.2" y1="14.04" x2="18.62" y2="16.54" />
      <line class="st0" x1="24.91" y1="11.48" x2="24.9" y2="14.36" />
      <line class="st0" x1="32.84" y1="13.78" x2="31.4" y2="16.26" />
      <line class="st0" x1="38.68" y1="19.57" x2="36.19" y2="20.99" />
      <line class="st0" x1="40.9" y1="27.39" x2="38.03" y2="27.38" />
      <line class="st0" x1="38.59" y1="35.45" x2="36.1" y2="34" />
      <path
        class="st1"
        d="M26.38,35.39c0.57,0.44,0.93,1.13,0.93,1.9c0,1.33-1.08,2.41-2.41,2.41s-2.41-1.08-2.41-2.41
		c0-0.66,0.27-1.27,0.7-1.7l1.7-17.1L26.38,35.39z"
      />
    </g>
    <g id="kader" class="st2">
      <g class="st3">
        <g>
          <g>
            <path
              class="st4"
              d="M46.38,1.13c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.66
					c-1.47,0-2.66-1.19-2.66-2.66V3.8c0-1.47,1.19-2.66,2.66-2.66H46.38 M46.38,0.13H3.66c-2.02,0-3.66,1.64-3.66,3.66v42.72
					c0,2.02,1.64,3.66,3.66,3.66h42.72c2.02,0,3.66-1.64,3.66-3.66V3.8C50.04,1.77,48.4,0.13,46.38,0.13L46.38,0.13z"
            />
          </g>
        </g>
        <rect x="5.53" y="5.8" class="st5" width="39" height="39" />
      </g>
      <g class="st3">
        <g>
          <path
            class="st4"
            d="M46.38,1.13c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.66c-1.47,0-2.66-1.19-2.66-2.66
				V3.8c0-1.47,1.19-2.66,2.66-2.66H46.38 M46.38,0.13H3.66c-2.02,0-3.66,1.64-3.66,3.66v42.72c0,2.02,1.64,3.66,3.66,3.66h42.72
				c2.02,0,3.66-1.64,3.66-3.66V3.8C50.04,1.77,48.4,0.13,46.38,0.13L46.38,0.13z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconBarometer extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}

.st1 {
  fill: none;
  stroke: #000000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.st2 {
  display: none;
}

.st3 {
  display: inline;
}

.st4 {
  fill: #0a0a0a;
}

.st5 {
  fill: none;
  stroke: #00aae1;
  stroke-miterlimit: 10;
}
</style>
